import {BaseTerms} from "../../infrastructure/models/base-terms";

export class ScoreboardWidgetTerms extends BaseTerms {
  WEB_GAME_CENTER_SCOREBOARD = "Scoreboard";
  WEB_GC_SCOREBOARD_GAME_TIME = "Match Time";
}
